<template>
  <div class="main">
    <p class="breadcrumb">您的位置：首页 > 产品列表页</p>
    <img :src="banner" alt="" class="banner" v-if="banner" />
    <div class="conditions" v-if="conditionShow && conditionShowB">
      <!-- 如果是 一站式进来 就不显示筛选条件 -->
      <div
        class="flexbox cell"
        v-for="(item, index) in conditionList"
        :key="index"
        :style="{ height: item.height }"
      >
        <div class="condleft" style="height: 40px; line-height: 40px">
          {{ item.typename }}：
        </div>
        <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'ly'">
          <li
            v-for="it in item.typelist"
            :key="it.ID"
            :style="{
              color: selcondition.ly == it.ID ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.ID, item.typeh, it.FIELD)"
          >
            {{ it.NAME }}
          </li>
        </ul>
        <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'pp'">
          <li
            v-for="it in item.typelist"
            :key="it.ID"
            :style="{
              color: selcondition.pp == it.ID ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.ID, item.typeh, it.FIELD)"
          >
            {{ it.NAME }}
          </li>
        </ul>
        <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'fl'">
          <li
            v-for="it in item.typelist"
            :key="it.ID"
            :style="{
              color: selcondition.fl == it.ID ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.ID, item.typeh, it.FIELD)"
          >
            {{ it.NAME }}
          </li>
        </ul>
        <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'bhxs'">
          <li
            v-for="it in item.typelist"
            :key="it.ID"
            :style="{
              color: selcondition.bhxs == it.ID ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.ID, item.typeh, it.FIELD)"
          >
            {{ it.NAME }}
          </li>
        </ul>
        <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'gg'">
          <li
            v-for="it in item.typelist"
            :key="it.ID"
            :style="{
              color: selcondition.gg == it.ID ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.ID, item.typeh, it.FIELD)"
          >
            {{ it.NAME }}
          </li>
        </ul>
        <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'cz'">
          <li
            v-for="it in item.typelist"
            :key="it.ID"
            :style="{
              color: selcondition.cz == it.ID ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.ID, item.typeh, it.FIELD)"
          >
            {{ it.NAME }}
          </li>
        </ul>
         <ul class="flexbox condright" :ref="setRef" v-if="item.typeh == 'cp'">
          <li
            v-for="it in item.typelist"
            :key="it.ID"
            :style="{
              color: selcondition.cp == it.ID ? 'rgb(244,36,52)' : '#000',
            }"
            @click="conditionSelect(it.ID, item.typeh, it.FIELD)"
          >
            {{ it.NAME }}
          </li>
        </ul>
        <div
          class="morebtn"
          @click="moreCondition(index)"
          :style="{ height: item.height }"
        >
          {{ item.isMore }}
        </div>
      </div>
    </div>
    <div class="flexbox maincon">
      <div class="left">
        <h3>商品推荐</h3>
        <ul>
          <li
            v-for="item in recommendList"
            :key="item.TGN_ID"
            @click="
              pageToDetail(
                item.MGM_GOODS_JPPZID,
                item.MGM_GOODS_CZID,
                item.MGM_GOODS_XSISSPLIT,
                item.FIELD
              )
            "
          >
            <div class="pic"><img :src="item.MGM_GOODSPIC_MAIN" /></div>
            <!-- <p class="redw">¥ {{ item.MONEY }}</p> -->
            <div class="name">{{ item.MGM_LONG_DESC }}</div>
          </li>
        </ul>
      </div>
      <div class="right">
        <div class="fieldTab" v-if="type == 'field'">
          <span @click="clickFieldTab('')">全部</span>
          <span
            v-for="(item, index) in fieldTabList"
            :key="index"
            @click="clickFieldTab(item)"
            >{{ item.TGC_NAME }}</span
          >
        </div>

        <!-- X -->
        <div class="" v-if="goodsList.length > 0 && pageType == 'X'">
          <!-- <div class="flexbox condi">
                    <div class="cell bordercell" :class=" { on: normalcondition.zh != '' }" @click="condiSwitch('zh')">
                        <span>综合</span>
                    </div>
                    <div class="cell bordercell" :class=" { on: normalcondition.zx != '' }" @click="condiSwitch('zx')">
                        <span>最新上架</span>
                    </div>
                    <div class="flexbox cell bordercell" :class=" { on: normalcondition.jg != '' }" @click="condiSwitch('jg')">
                        <span>价格</span>
                        <span class="flexbox">
                            <i class="el-icon-caret-top" :style="{color: normalcondition.jg == 'Y'? 'rgb(244,36,52)': '#ccc'}"></i>
                            <i class="el-icon-caret-bottom" :style="{color: normalcondition.jg == 'N'? 'rgb(244,36,52)': '#ccc'}"></i>
                        </span>
                    </div>
                    <div class="flexbox cell inputcell">
                        <el-input v-model="normalcondition.min" placeholder="¥"></el-input>
                        -
                        <el-input v-model="normalcondition.max" placeholder="¥"></el-input>
                         <el-button @click="condiSwitch('jgqj')">确定</el-button>
                    </div>
                </div> -->
          <h1 class="ht">{{ htitle }}</h1>
          <ul class="flexbox goodscon">
            <li v-for="(item, index) in goodsList" :key="index">
              <div
                class="pic"
                @click="
                  pageToDetail(
                    item.MGM_GOODS_JPPZID,
                    item.MGM_GOODS_CZID,
                    item.MGM_GOODS_XSISSPLIT,
                    item.FIELD
                  )
                "
              >
                <img :src="item.MGM_GOODSPIC_MAIN" />
              </div>
              <!-- <p class="redw">¥ {{item.MONEY}} ~ ¥ {{ item.MONEY1 }}</p> -->
              <div class="name">{{ item.MGM_LONG_DESC }}</div>
              <div
                class="flexbox col"
                v-if="item.ISSHOUCANG == 'N'"
                @click="
                  productCollect(
                    item.MGM_GOODS_JPPZID,
                    item.MGM_GOODS_XSISSPLIT,
                    item.MGM_GOODS_CZID
                  )
                "
              >
                <!-- <i class="el-icon-star-off"></i> -->
                <img
                  src="../../assets/img/icon/no_star.svg"
                  style="width: 12px; height: 12px"
                />

                <span>收藏</span>
              </div>
              <div
                class="flexbox col coled"
                v-if="item.ISSHOUCANG == 'Y'"
                @click="
                  productCollect(
                    item.MGM_GOODS_JPPZID,
                    item.MGM_GOODS_XSISSPLIT,
                    item.MGM_GOODS_CZID
                  )
                "
              >
                <!-- <i class="el-icon-star-on"></i> -->
                <img
                  src="../../assets/img/icon/star.svg"
                  style="width: 12px; height: 12px"
                />
                <span>已收藏</span>
              </div>
            </li>
          </ul>
          <el-pagination
            @current-change="handleCurrentChange"
            v-model:currentPage="currentPage"
            :page-size="20"
            :total="totalNum"
            layout="prev, pager, next, jumper"
            background
          ></el-pagination>
        </div>
        <!-- H -->
        <div class="" v-if="goodsList.length > 0 && pageType == 'H'">
          <!-- <div class="fieldTab">
          <span @click="clickFieldTab('')">全部</span>
          <span v-for="(item, index) in fieldTabList" :key="index" @click="clickFieldTab(item)">{{
            item.TGC_NAME
          }}</span>
        </div> -->
          <div
            class="flexbox condi"
            v-if="
              type !== 'brand' &&
              type !== 'oneStopList' &&
              type !== 'oneStopList_FL' &&
              type !== 'field'
            "
          >
            <div
              class="cell bordercell"
              :class="{ on: normalcondition.sortCol == 'zhSort' }"
              @click="condiSwitchan('zhSort')"
            >
              <span>综合</span>
            </div>
            <div
              class="cell bordercell"
              :class="{ on: normalcondition.sortCol == 'newest' }"
              @click="condiSwitchan('newest')"
            >
              <span>最新上架</span>
            </div>
            <div
              class="flexbox cell bordercell"
              :class="{ on: normalcondition.sortCol == 'priceSort' }"
              @click="condiSwitchan('priceSort')"
            >
              <span>价格</span>
              <span class="flexbox">
                <img
                  v-if="
                    normalcondition.sortCol == 'priceSort' &&
                    normalcondition.sort == 'z'
                  "
                  src="../../assets/img/icon/shengxu_hui.svg"
                />
                <img v-else src="../../assets/img/icon/shengxu_hong.svg" />

                <img
                  v-if="
                    normalcondition.sortCol == 'priceSort' &&
                    normalcondition.sort == 'f'
                  "
                  src="../../assets/img/icon/jiangxu_hui.svg"
                />
                <img v-else src="../../assets/img/icon/jiangxu_hong.svg" />

                <!--                             
                            <i class="el-icon-caret-top" :style="{color: normalcondition.sortCol == 'priceSort' && normalcondition.sort == 'z'? 'rgb(244,36,52)': '#ccc'}"></i>
                            <i class="el-icon-caret-bottom" :style="{color: normalcondition.sortCol == 'priceSort' && normalcondition.sort == 'f'? 'rgb(244,36,52)': '#ccc'}"></i> -->
              </span>
            </div>
            <div class="flexbox cell inputcell">
              <el-input
                v-model="normalcondition.min"
                placeholder="¥"
              ></el-input>
              -
              <el-input
                v-model="normalcondition.max"
                placeholder="¥"
              ></el-input>
              <el-button @click="condiSwitchan('jgqj')">确定</el-button>
            </div>
          </div>
          <ul class="flexbox goodscon">
            <li v-for="(item, index) in goodsList" :key="index">
              <div
                class="pic"
                @click="pageToDetail(item.pz, item.cz, item.bhxs, item.field)"
              >
                <img :src="item.img" />
              </div>
              <!-- <p class="redw">¥ {{item.minPrice}} ~ ¥ {{ item.maxPrice }}</p> -->
              <div class="name">{{ item.longDesc }}</div>
              <div
                class="flexbox col"
                v-if="!item.collectSign"
                @click="productCollect(item.pz, item.bhxs, item.cz)"
              >
                <i class="el-icon-star-off"></i>
                <span>收藏</span>
              </div>
              <div
                class="flexbox col coled"
                v-if="item.collectSign"
                @click="productCollect(item.pz, item.bhxs, item.cz)"
              >
                <i class="el-icon-star-on"></i>
                <span>已收藏</span>
              </div>
            </li>
          </ul>
          <el-pagination
            @current-change="handleCurrentChange"
            v-model:currentPage="currentPage"
            :page-size="20"
            :total="totalNum"
            layout="prev, pager, next, jumper"
            background
          ></el-pagination>
        </div>
        <div class="right nodata" v-if="goodsList.length == 0">
          <el-empty description="暂无符合条件的产品"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount } from "vue";
import { useRouter, onBeforeRouteUpdate } from "vue-router";
import { ElMessage } from "element-plus";

export default {
  name: "GoodsList",
  components: {},
  setup() {
    let router = useRouter();
    let { proxy } = getCurrentInstance();
    let pageType = ref("");
    // 获取数据
    let pageData = reactive({
      conditionList: [
        {
          typename: "领域",
          typeh: "ly",
          typelist: [{ ID: "", NAME: "全部" }],
          height: "40px",
          isMore: "更多",
        },
        {
          typename: "品牌",
          typeh: "pp",
          typelist: [{ ID: "", NAME: "全部" }],
          height: "40px",
          isMore: "更多",
        },
        {
          typename: "三级分类",
          typeh: "fl",
          typelist: [{ ID: "", NAME: "全部" }],
          height: "40px",
          isMore: "更多",
        },
        {
          typename: "销售类别形式",
          typeh: "bhxs",
          typelist: [{ ID: "", NAME: "全部" }],
          height: "40px",
          isMore: "更多",
        },
        {
          typename: "规格",
          typeh: "gg",
          typelist: [{ ID: "", NAME: "全部" }],
          height: "40px",
          isMore: "更多",
        },
        {
          typename: "材质",
          typeh: "cz",
          typelist: [{ ID: "", NAME: "全部" }],
          height: "40px",
          isMore: "更多",
        },
          {
          typename: "产品",
          typeh: "cp",
          typelist: [{ ID: "", NAME: "全部" }],
          height: "40px",
          isMore: "更多",
        },
      ],
      recommendList: [],
      goodsList: [],
      htitle: "",
      // 查询产品参数
      goodsParam: {
        ptype: "",
        keywords: "",
        searchcontent: "",
      },
      // 特殊筛选条件
      selcondition: {
        gg: "", // 尺寸ID （示例 1  ）
        cz: "", // 材质ID（示例 108 ）
        pp: "", // 品牌ID（示例 MATCO ）
        bhxs: "", // 包含形式ID（示例 117  ）
        fl: "", // 分类ID（示例 77 ）
        ly: "", // 领域ID（示例 1 ）
        cp:'',
      },
      // 通用筛选条件
      normalcondition: {
        zh: "", // 综合排序
        zx: "", // 上架时间排序
        jg: "", // 价格排序
        min: "", // 价格最小值
        max: "", // 价格最大值
        sortCol: "", // 1.综合：zhSort；2.上架时间：newest3.价格：priceSort
        sort: "", // 排序规则。1.正序(从小到大)：z；2.反序：f
      },
    });
    // 分类筛选
    let conditionSelect = (id, type, field) => {

    
      pageData.goodsParam.ptype = "querymenu";
      pageData.goodsParam.field = field;
      if (type == "ly") {
        pageData.selcondition.ly = id;
      } else if (type == "pp") {
        pageData.selcondition.pp = id;
      } else if (type == "fl") {
        pageData.selcondition.fl = id;
      } else if (type == "gg") {
        pageData.selcondition.gg = id;
      } else if (type == "bhxs") {
        pageData.selcondition.bhxs = id;
      } else if (type == "cz") {
        pageData.selcondition.cz = id;
      }else if(type=='cp'){
        pageData.selcondition.cp = id;
        
       

      }
      let data = {
        postType: "clickly",
        info: pageData.goodsParam.searchcontent, // 产品编码/长描述/中文名称(模糊查询)
        classid: pageData.selcondition.fl, // 分类
        // lyid: pageData.selcondition.ly, // 领域
        brand: pageData.selcondition.pp, // 品牌(模糊查询)
        cz: pageData.selcondition.cz, // 材质(模糊查询)
        xs: pageData.selcondition.bhxs, // 形式(模糊查询)

        lyid: pageData.goodsParam.field || pageData.selcondition.ly,
        cp:pageData.selcondition.cp 
        // gg: pageData.selcondition.gg, // 规格(模糊查询)

        // bm: '', // 表面(模糊查询)
      };

      proxy.$axios
        .postReq("/meide/REST/ajaxMdSearchResult", data)
        .then((res) => {
          // if (res.success == "true") {
          pageData.conditionList.map((item) => {
            item.typelist = [{ ID: "", NAME: "全部" }];
          });
          let ary = [];
          let list = ary.concat(
            res["1"],
            res["2"],
            res["3"],
            res["4"],
            res["5"],
            res["6"],
            res["7"],
          );
          list.map((item) => {
            if (item.TYPE == "LINGYU") {
              pageData.conditionList[0].typelist.push(item);
            } else if (item.TYPE == "BRAND") {
              pageData.conditionList[1].typelist.push(item);
            } else if (item.TYPE == "CLASS") {
              pageData.conditionList[2].typelist.push(item);
            } else if (item.TYPE == "BHXS") {
              pageData.conditionList[3].typelist.push(item);
            } else if (item.TYPE == "SIZE") {
              pageData.conditionList[4].typelist.push(item);
            } else if (item.TYPE == "CAIZHI") {
              pageData.conditionList[5].typelist.push(item);
            }
             else if (item.TYPE == "CHANPIN") {
              pageData.conditionList[6].typelist.push(item);
            }
          });
          conditionShow.value = true;
          // pageData.conditionList = res.items
          // } else {
          //   proxy.$alert(res.ErrorText, "提示", {
          //     confirmButtonText: "确定",
          //     callback: (action) => {},
          //   });
          // }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
      getGoodsList();
    };
    // 通用条件筛选
    // X
    let condiSwitch = (type) => {
      if (type == "jgqj") {
        for (let key in pageData.normalcondition) {
          if (key != "min" && key != "max") {
            pageData.normalcondition[key] = "";
          }
        }
        if (
          pageData.normalcondition.min == "" ||
          pageData.normalcondition.max == ""
        ) {
          ElMessage.warning({
            message: "价格区间不能为空！",
            type: "warning",
          });
        } else if (
          parseFloat(pageData.normalcondition.min) >
          parseFloat(pageData.normalcondition.max)
        ) {
          ElMessage.warning({
            message: "最低价格不能高于最高价格！",
            type: "warning",
          });
        } else {
          // 价格区间正常
        }
      } else if (type == "jg") {
        for (let key in pageData.normalcondition) {
          if (key != "jg") {
            pageData.normalcondition[key] = "";
          }
        }
        if (pageData.normalcondition.jg == "Y") {
          pageData.normalcondition.jg = "N";
        } else {
          pageData.normalcondition.jg = "Y";
        }
      } else {
        for (let key in pageData.normalcondition) {
          pageData.normalcondition[key] = "";
        }
        if (type == "zh") {
          pageData.normalcondition.zh = "Y";
        } else if (type == "zx") {
          pageData.normalcondition.zx = "Y";
        }
      }
      getGoodsList();
    };
    // H
    let condiSwitchan = (type) => {
      if (type == "jgqj") {
        for (let key in pageData.normalcondition) {
          if (key != "min" && key != "max") {
            pageData.normalcondition[key] = "";
          }
        }
        if (
          pageData.normalcondition.min == "" ||
          pageData.normalcondition.max == ""
        ) {
          ElMessage.warning({
            message: "价格区间不能为空！",
            type: "warning",
          });
        } else if (
          parseFloat(pageData.normalcondition.min) >
          parseFloat(pageData.normalcondition.max)
        ) {
          ElMessage.warning({
            message: "最低价格不能高于最高价格！",
            type: "warning",
          });
        } else {
          // 价格区间正常
        }
      } else {
        if (type == "priceSort") {
          pageData.normalcondition.sortCol = type;
          if (pageData.normalcondition.sort == "z") {
            pageData.normalcondition.sort = "f";
          } else {
            pageData.normalcondition.sort = "z";
          }
        } else {
          pageData.normalcondition.sortCol = type;
          pageData.normalcondition.sort = "z";
        }
      }
      getGoodsList();
    };
    // 分页
    let currentPage = ref(1);
    let totalNum = ref(0);
    let handleCurrentChange = (val) => {
      currentPage.value = val;
      getGoodsList();
    };
    // 获取产品条件
    let conditionShow = ref(false);
    let conditionShowB = ref(false); // 如果是从首页更多进入则无需筛选条件
    let getGoodCondition = () => {
      let data = null;

      if (pageData.goodsParam.ptype == "querymenu") {
        // 导航进入
        data = {
          postType: pageData.goodsParam.ptype,
          classid: pageData.goodsParam.keywords,
        };
        conditionShowB.value = true;
      } else if (pageData.goodsParam.ptype == "querysearch") {
        // 搜索进入 & 普通进入
        data = {
          postType: pageData.goodsParam.ptype,
          searchinfo: pageData.goodsParam.searchcontent,
        };
        conditionShowB.value = true;
      } else if (pageData.goodsParam.ptype == "querymore") {
        // 首页更多进入
        data = {
          postType: pageData.goodsParam.ptype,
          type: pageData.goodsParam.keywords, //推荐类型
        };
        conditionShowB.value = false;
        return;
      } else {
        data = {
          postType: "querysearch",
          searchinfo: pageData.goodsParam.keywords,
        };
        conditionShowB.value = true;
      }

      proxy.$axios
        .postReq("/meide/REST/ajaxMdSearchResult", data)
        .then((res) => {
          // if (res.success == "true") {
          pageData.conditionList.map((item) => {
            item.typelist = [{ ID: "", NAME: "全部" }];
          });
          let ary = [];
          let list = ary.concat(
            res["1"],
            res["2"],
            res["3"],
            res["4"],
            res["5"],
            res["6"],
            res["7"],
          );

          list.map((item) => {
            if (item.TYPE == "LINGYU") {
              pageData.conditionList[0].typelist.push(item);
            } else if (item.TYPE == "BRAND") {
              pageData.conditionList[1].typelist.push(item);
            } else if (item.TYPE == "CLASS") {
              pageData.conditionList[2].typelist.push(item);
            } else if (item.TYPE == "BHXS") {
              pageData.conditionList[3].typelist.push(item);
            } else if (item.TYPE == "SIZE") {
              pageData.conditionList[4].typelist.push(item);
            } else if (item.TYPE == "CAIZHI") {
              pageData.conditionList[5].typelist.push(item);
            } else if (item.TYPE == "CHANPIN") {
              pageData.conditionList[6].typelist.push(item);
            }
          });
          conditionShow.value = true;
          // pageData.conditionList = res.items
          // } else {
          //   proxy.$alert(res.ErrorText, "提示", {
          //     confirmButtonText: "确定",
          //     callback: (action) => {},
          //   });
          // }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 产品条件展开收起
    let cdtCell = ref([]);
    let setRef = (el) => {
      cdtCell.value.push(el);
    };
    let moreCondition = (idx) => {
      if (pageData.conditionList[idx].isMore == "更多") {
        pageData.conditionList[idx].height =
          cdtCell.value[idx].offsetHeight + "px";
        pageData.conditionList[idx].isMore = "收起";
      } else {
        pageData.conditionList[idx].height = "40px";
        pageData.conditionList[idx].isMore = "更多";
      }
    };
    // 获取侧边推荐商品
    let getRecommendList = () => {
      let data = {
        postType: "queryzngoods",
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxMdIndex", data)
        .then((res) => {
          if (res.success == "true") {
            res.items.map((item, index) => {
              if (index < 5) {
                pageData.recommendList.push(item);
              }
            });
            // pageData.recommendList = res.items
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 获取主体商品
    let goodslistShow = ref(false);
    let getGoodsList = () => {
      console.log(type.value, 888888);
      let data = null;
      let url = "";

      if (pageData.goodsParam.ptype == "querymore") {
        // 首页更多进入-X
        url = "/meide/REST/ajaxMdSearchResult";
        data = {
          // field:pageData. selcondition.ly,
          postType: "querytjlist",
          type: pageData.goodsParam.keywords,
          SIZEID: pageData.selcondition.gg, // 尺寸ID （示例 1  ）
          CAIZHIID: pageData.selcondition.cz, // 材质ID（示例 108 ）
          BRANDID: pageData.selcondition.pp, // 品牌ID（示例 MATCO ）
          BHXSID: pageData.selcondition.bhxs, // 包含形式ID（示例 117）
          CLASSID: pageData.selcondition.fl, // 分类ID（示例 77 ）
          LINGYUID: pageData.selcondition.ly, // 领域ID（示例 1 ）
          ZHONGHE: pageData.normalcondition.zh, // 综合排序
          SXJ: pageData.normalcondition.zx, // 上架时间排序
          PRICE: pageData.normalcondition.jg, // 价格排序
          MIN: pageData.normalcondition.min, // 价格最小值
          MAX: pageData.normalcondition.max, // 价格最大值
          start: currentPage.value, // 第几页
          limit: "20", // 一页展示多少个
        };
      } else if (type.value == "brand") {
        url = "/meide/REST/ajaxMdSearchResult";
        data = {
          postType: "querybrandgoods",
          code: code.value,
          start: currentPage.value, // 起始页，默认1
          limit: "20", // 每页多少条，默认20
        };
      } else if (type.value == "oneStopList") {
        url = "/meide/REST/ajaxMdIndex";
        data = {
          postType: "queryyzsmx",
          TGS_ID: TGS_ID.value,
          start: currentPage.value, // 起始页，默认1
          limit: "20", // 每页多少条，默认20
        };
      } else if (type.value == "oneStopList_FL") {
        url = "/meide/REST/ajaxMdIndex";
        data = {
          postType: "queryyzsflmx",
          classid: classid.value,
          start: currentPage.value, // 起始页，默认1
          limit: "20", // 每页多少条，默认20
        };
      } else if (type.value == "field") {
        url = "/meide/REST/ajaxField";
        data = {
          postType: "queryerclassgoods",
          classyiid: fieldid.value,
          start: currentPage.value, // 起始页，默认1
          limit: "20", // 每页多少条，默认20
          classerid: classerid.value, //二级
        };
      } else {
        let type = "";
        //首页菜单
        if (pageData.goodsParam.ptype == "querymenu") {
          type = "menu";
        } else if (pageData.goodsParam.ptype == "querysearch") {
          type = "input";
        }
        // 其他进入-H
        url = "/meide/REST/ajaxSelectProduct";
        data = {
          type,
          field: pageData.goodsParam.field || pageData.selcondition.ly,
          postType: "queryPicProductList",
          start: currentPage.value, // 起始页，默认1
          limit: "20", // 每页多少条，默认20
          // field: pageData.selcondition.ly, // 领域
          class: pageData.selcondition.fl, // 分类
          product: pageData.goodsParam.searchcontent, // 产品编码/长描述/中文名称(模糊查询)
          project: "", // 合同号，项目订单用，筛选该项目维护的所有产品
          stock: "", // 异地仓编码，异地仓订单用，筛选出该异地仓有的且库存大于0的产品
          pp: pageData.selcondition.pp, // 品牌(模糊查询)
          gg: pageData.selcondition.gg, // 规格(模糊查询)
          cz: pageData.selcondition.cz, // 材质(模糊查询)
          xs: pageData.selcondition.bhxs, // 形式(模糊查询)
          bm: "", // 表面(模糊查询)
          priceStart: pageData.normalcondition.min, // 价格范围筛选(最低)
          priceEnd: pageData.normalcondition.max, // 价格范围筛选(最高)
          sortCol: pageData.normalcondition.sortCol, //	结果排序依据。1.综合：zhSort；2.上架时间：newest3.价格：priceSort
          sort: pageData.normalcondition.sort, // 排序规则。1.正序(从小到大)：z；2.反序：f
        };
      }
      proxy.$axios
        .postReq(url, data)
        .then((res) => {
          if (res.success == "true") {
            if (res.items) {
              pageData.goodsList = res.items;
            } else {
              pageData.goodsList = res.data;
            }
            totalNum.value = parseInt(res.rowcount);
            goodslistShow.value = true;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 收藏
    let colClick = ref(true);
    let productCollect = (pz, xs, cz) => {
      if (colClick.value) {
        colClick.value = false;
        let data = {
          postType: "collection",
          MGM_GOODS_JPPZID: pz, // 品种
          MGM_GOODS_XSISSPLIT: xs, // 形式
          MGM_GOODS_CZID: cz, // 材质
        };
        proxy.$axios
          .postReq("/meide/REST/ajaxMdCollection", data)
          .then((res) => {
            if (res.success == "true") {
              ElMessage.success({
                message: res.Info,
                type: "success",
              });
              getGoodsList();
              colClick.value = true;
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  colClick.value = true;
                },
              });
            }
          })
          .catch((error) => {
            proxy.$alert(error, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                colClick.value = true;
              },
            });
          });
      }
    };
    // 跳转产品详情
    let pageToDetail = (pz, cz, xs, field) => {
      router.push({
        name: "ProductDetails",
        query: {
          pz: pz,
          cz: cz,
          xs: xs,
          field: field,
        },
      });
    };
    // 搜索页面进行搜索
    onBeforeRouteUpdate((to, from) => {
      for (let key in pageData.selcondition) {
        pageData.selcondition[key] = "";
      }
      for (let key in pageData.normalcondition) {
        pageData.normalcondition[key] = "";
      }
      pageData.goodsParam.field = "";
      pageData.goodsParam.ptype = to.query.type
        ? to.query.type
        : pageData.goodsParam.ptype;
      pageData.goodsParam.keywords = to.query.keywords
        ? to.query.keywords
        : pageData.goodsParam.keywords;
      pageData.goodsParam.searchcontent = to.query.searchcontent
        ? to.query.searchcontent
        : pageData.goodsParam.searchcontent;
      getGoodsList();
      getGoodCondition();
    });
    let code = ref("");
    let type = ref("");
    let banner = ref("");
    let TGS_ID = ref("");
    let classid = ref("");
    let fieldid=ref('')
    onBeforeMount(() => {
      code.value = router.currentRoute.value.query.code; //品牌编码
      type.value = router.currentRoute.value.query.type; //从哪来跳过来的  brand onestoplist  oneStopList_FL
      TGS_ID.value = router.currentRoute.value.query.TGS_ID; //onestoplist 和 fl  跳过来用得到
      classid.value = router.currentRoute.value.query.classid; //onestoplist_fl跳过来用得到  领域field跳过来用得到  应用领域id
         fieldid.value= router.currentRoute.value.query.fieldid; // 领域field跳过来用得到  领域id
      pageData.goodsParam.field = router.currentRoute.value.query.field
        ? router.currentRoute.value.query.field
        : "";
      pageData.goodsParam.ptype = router.currentRoute.value.query.type
        ? router.currentRoute.value.query.type
        : "";
      pageData.goodsParam.keywords = router.currentRoute.value.query.keywords
        ? router.currentRoute.value.query.keywords
        : "";
      pageData.goodsParam.searchcontent = router.currentRoute.value.query
        .searchcontent
        ? router.currentRoute.value.query.searchcontent
        : "";
      console.log(code, type, 999);
      if (pageData.goodsParam.ptype == "querymore") {
        pageType.value = "X";
        if (pageData.goodsParam.keywords == "zntj") {
          pageData.htitle = "智能推荐";
        } else if (pageData.goodsParam.keywords == "cgqd") {
          pageData.htitle = "常购清单";
        } else if (pageData.goodsParam.keywords == "bktj") {
          pageData.htitle = "爆款推荐";
        } else if (pageData.goodsParam.keywords == "xptj") {
          pageData.htitle = "新品机会";
        }
      } else {
        pageType.value = "H";
        if (pageData.goodsParam.ptype == "querymenu") {
          pageData.selcondition.fl = pageData.goodsParam.keywords;
        }
      }

      getGoodsList();
      getGoodCondition();
      getRecommendList();

      //如果是品牌，就不展示上面的筛选和价格栏筛选,展示banner
      if (type.value == "brand") {
        conditionShowB.value = false;
        //获取顶部banner
        proxy.$axios
          .postReq("/meide/REST/ajaxMdSearchResult", {
            postType: "querydesc",
            code: code.value,
          })
          .then((res) => {
            if (res.success == "true") {
              banner.value = res.items[0].TBD_DESC;
            }
          });
      }
      // 一站式同上
      if (type.value == "oneStopList" || type.value == "oneStopList_FL") {
        conditionShowB.value = false;
        //获取顶部banner
        proxy.$axios
          .postReq("/meide/REST/ajaxMdIndex", {
            postType: "queryyzspic",
            TGS_ID: TGS_ID.value,
          })
          .then((res) => {
            if (res.success == "true") {
              banner.value = res.items[0].TGS_PICLIST;
            }
          });
      }
      // 领域同上
      if (type.value == "field") {
        conditionShowB.value = false;
        //获取顶部banner
        proxy.$axios
          .postReq("/meide/REST/ajaxField", {
            postType: "querylingyudesc",
            classyiid: classid.value,
          })
          .then((res) => {
  
            if (res.success == "true") {
              banner.value = res.items[0].TIF_DESCPIC;
            }
          });
        //应用领域二级分类查询
        proxy.$axios
          .postReq("/meide/REST/ajaxField", {
            postType: "queryerclass",
            classid: fieldid.value,
          })
          .then((res) => {
            if (res.success == "true") {
              fieldTabList.value = res.items;
            }
          });
      }

      console.log(pageData.goodsList, "------goodslist----");
    });
    let fieldTabList = ref([]);
    let classerid = ref(""); //领域查询商品的二级分类
    let clickFieldTab = (item) => {
      if (item) {
        classerid.value = item.TGC_ID;
      } else {
        classerid.value = "";
      }
      getGoodsList();
    };
    return {
      pageType,
      ...toRefs(pageData),
      conditionShow,
      conditionShowB,
      getGoodCondition,
      getRecommendList,
      goodslistShow,
      getGoodsList,
      cdtCell,
      setRef,
      moreCondition,
      conditionSelect,
      condiSwitch,
      condiSwitchan,
      currentPage,
      totalNum,
      handleCurrentChange,
      colClick,
      productCollect,
      pageToDetail,
      banner,
      type,
      fieldTabList,
      clickFieldTab,
    };
  },
};
</script>

<style scoped lang="scss">
.main {
  background: #fafafa;
  padding-bottom: 50px;
}
.breadcrumb {
  width: 1200px;
  margin: 10px auto;
  color: #666;
  font-size: 12px;
}
.conditions {
  width: 1200px;
  margin: auto;
  border: 1px solid rgba(223, 223, 223, 1);
  background: #fff;
  .cell {
    border-bottom: 1px solid rgba(223, 223, 223, 1);
    background: rgba(245, 245, 245, 1);
    align-items: flex-start;
    height: 40px;
    overflow: hidden;
    .condleft {
      width: 130px;
      text-align: center;
      //   padding-top: 5px;
      font-size: 12px;
    }
    .condright {
      padding: 0 10px;
      flex-wrap: wrap;
      width: 1070px;
      background: #fff;
      min-height: 40px;
      li {
        margin: 10px;
        font-size: 12px;
        cursor: pointer;
        font-size: #333;
        &:hover {
          color: rgb(244, 36, 52);
        }
      }
    }
    .morebtn {
      color: rgb(244, 36, 52);
      width: 150px;
      text-align: right;
      height: 40px;
      line-height: 40px;
      background: #fff;
      padding-right: 25px;
      font-size: 12px;
      cursor: pointer;
    }
    &:last-child {
      border: none;
    }
  }
}
.maincon {
  width: 1200px;
  margin: auto;
  margin-top: 40px;
  justify-content: space-between;
  align-items: flex-start;
  .ht {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 30px;
    padding-left: 15px;
  }
  .left {
    padding: 15px;
    width: 16%;
    background: #fff;
    border: 1px solid rgba(223, 223, 223, 1);
    h3 {
      text-align: center;
      font-weight: bold;
      margin-bottom: 20px;
    }
    ul {
      li {
        border-top: 1px dashed #999;
        padding-bottom: 15px;
        .pic {
          text-align: center;
          padding: 10px 0;
          cursor: pointer;
          img {
            width: 150px;
            height: 150px;
          }
        }
        .redw {
          margin: 5px 0;
          text-align: left;
          font-size: 12px;
        }
        .name {
          font-size: 12px;
          text-align: left;
          height: 48px;
          overflow: hidden;
        }
      }
    }
  }
  .right {
    padding: 20px 0 30px 15px;
    background: #fff;
    width: 80%;
    .condi {
      .cell {
        height: 30px;
        line-height: 30px;
        span {
          font-size: 12px;
          color: #333;
          i {
            color: #fff;
          }
        }
      }
      .bordercell {
        border: 1px solid rgba(223, 223, 223, 1);
        padding: 0 20px;
        cursor: pointer;
        &.on,
        &:hover {
          background: rgb(244, 36, 52);
          border-color: rgb(244, 36, 52);
          span,
          i {
            color: #fff;
          }
        }
        span.flexbox {
          flex-direction: column;
          justify-content: center;
          margin-left: 5px;
          i {
            line-height: 0.5;
          }
        }
      }
      .inputcell {
        margin-left: 10px;
        ::v-deep(.el-input__inner) {
          width: 80px;
          height: 30px;
          margin: 0 3px;
        }
        ::v-deep(.el-button) {
          min-height: 10px;
          width: 70px;
          height: 30px;
          line-height: 0;
          font-size: 12px;
          color: #fff;
          border: none;
          background: rgba(244, 36, 52, 0.7);
          &:hover {
            background: rgba(244, 36, 52, 1);
          }
        }
      }
    }
    .goodscon {
      flex-wrap: wrap;
      padding: 10px;
      margin-bottom: 10px;
      li {
        width: 18.5%;
        margin: 0 6px;
        border: 1px solid rgba(223, 223, 223, 1);
        padding: 10px;
        margin-bottom: 15px;
        .pic {
          text-align: center;
          cursor: pointer;
          img {
            width: 150px;
            height: 150px;
          }
        }

        .redw {
          text-align: left;
          margin: 5px 0;
        }
        .name {
          font-size: 12px;
          text-align: left;
          height: 48px;
          overflow: hidden;
        }
        .col {
          margin-top: 15px;
          border: rgba(223, 223, 223, 1) 1px solid;
          width: 70px;
          height: 25px;
          line-height: 25px;
          justify-content: center;
          cursor: pointer;
          span {
            font-size: 12px;
            color: #666;
          }
          i {
            margin-right: 4px;
          }
          &:hover {
            border-color: rgb(244, 36, 52);
            span {
              color: rgb(244, 36, 52);
            }
            i {
              color: rgb(244, 36, 52);
            }
          }
        }
        .coled {
          border-color: rgb(244, 36, 52);
          span {
            font-size: 12px;
            color: rgb(244, 36, 52);
          }
          .el-icon-star-on {
            font-size: 17px;
            color: rgb(244, 36, 52);
          }
        }
      }
    }
    ::v-deep(.el-pagination) {
      text-align: center;
    }
    ::v-deep(.el-pagination.is-background .el-pager li:hover) {
      background: rgba(255, 0, 0, 1);
      color: #fff;
    }
    ::v-deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
      background: rgba(255, 0, 0, 1);
    }
  }
}
.banner {
  width: 1200px;
  height: 500px;
  margin: 0 auto;
  display: block;
}
.fieldTab {
  height: 40px;
  line-height: 40px;
  padding-left: 20px;

  span {
    margin-right: 20px;
    cursor: pointer;
  }
}
</style>